import styled from "styled-components";

export const ActivityFormThankContainerStyled = styled.div`
  padding: 20px 20px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .activity_form_thank_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .thank_label {
      margin-top: 120px;
      margin-bottom: 120px;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      white-space: pre-wrap;
    }
  }
  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 30px 20px;
    .breadcrumb_layout {
      display: none;
    }
  }
`;
